import { render } from "./PageBar.vue?vue&type=template&id=b11ee096"
import script from "./PageBar.vue?vue&type=script&lang=js"
export * from "./PageBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__